import LinkButton from "@components/buttons/LinkButton"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body16MainStyles,
  body18Styles,
  h2Styles,
  h4Styles,
} from "@constants/typography"
import styled from "styled-components"

export const Container = styled.div<{ reversed?: boolean }>`
  padding: 91px 0 72px;
  border-bottom: solid 1px ${colors.dividerLineGray};

  @media ${breakpoints.tablet} {
    padding: 108px 0 76px;
  }

  @media ${breakpoints.laptop} {
    padding: 131px 0 80px;
  }
`

export const TitleWrapper = styled.div`
  padding: 0 20px;

  @media ${breakpoints.tablet} {
    display: flex;
    padding: 0 calc(6 / 9 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    display: flex;
    padding: 0 calc(1 / 12 * 100vw);
  }
`

export const Title = styled.div<{ titleColSize: number }>`
  ${h4Styles}
  margin-bottom: 34px;

  @media ${breakpoints.tablet} {
    ${h2Styles}
    width: calc(4 / 12 * 100vw);
    margin-bottom: 80px;
  }

  @media ${breakpoints.laptop} {
    ${h2Styles}
    width: calc(${({ titleColSize }) => titleColSize} / 12 * 100vw);
    margin-bottom: 80px;
  }
`

export const Subtitle = styled.div`
  ${body16MainStyles}
  width: calc(1.5 / 2 * 100vw);

  @media ${breakpoints.tablet} {
    width: calc(5 / 12 * 100vw);
    margin-left: calc(1 / 12 * 100vw);
    padding-right: calc(0.5 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    ${body18Styles}
    width: calc(2 / 12 * 100vw);
    min-width: 230px;
    margin-left: calc(1 / 12 * 100vw);
  }
`

export const Cards = styled.div`
  padding: 46px 20px 53px;

  @media ${breakpoints.tablet} {
    display: flex;
    padding: 0 calc(6 / 9 / 12 * 100vw) 23px;
    justify-content: space-between;
  }

  @media ${breakpoints.laptop} {
    display: flex;
    padding: 75px calc(1 / 12 * 100vw) 23px;
    justify-content: space-between;
  }
`

export const CardWrapper = styled.div`
  margin-bottom: 24px;

  @media ${breakpoints.tablet} {
    width: calc(5 / 12 * 100vw);
    margin-bottom: 0;
  }

  @media ${breakpoints.laptop} {
    width: calc(1 / 3 * (100% - 76px));
    margin-bottom: 0;
  }
`

export const ButtonWrapper = styled.div`
  padding: 0 20px;

  @media ${breakpoints.tablet} {
    display: flex;
    padding: 0 calc(6 / 9 / 12 * 100vw) 0 0;
    justify-content: flex-end;
  }

  @media ${breakpoints.laptop} {
    display: flex;
    padding: 0 calc(1 / 12 * 100vw) 0 0;
    justify-content: flex-end;
  }
`

export const Button = styled(LinkButton)`
  margin-top: auto;
  width: 217px;

  @media ${breakpoints.laptop} {
    width: 256px;
  }
`
